import React, { useEffect, useState } from 'react'
import { errorPageApi, assetUrl } from '../services/api'

type Settings = {
  page_title?: string
  error_message?: string
  button_text?: string
  button_link?: string
  button_gradient_start?: string
  button_gradient_end?: string
  bg_color?: string
  bg_gradient_start?: string | null
  bg_gradient_end?: string | null
  text_color?: string
  font_family?: string | null
  background_image?: string | null
  background_size?: string | null
  custom_css?: string | null
}

const Error404: React.FC = () => {
  const [settings, setSettings] = useState<Settings>({})

  useEffect(() => {
    ;(async () => {
      try {
        const r = await errorPageApi.getSettings()
        if (r?.success) setSettings(r.data || {})
      } catch { void 0 }
      try {
        const s = localStorage.getItem('errorPageSettings')
        if (!settings.page_title && s) {
          const j = JSON.parse(s)
          setSettings(prev => ({ ...prev, ...j }))
        }
      } catch { void 0 }
    })()
  }, [])

  const bgStyle: React.CSSProperties = (() => {
    const gs = String(settings.bg_gradient_start || '')
    const ge = String(settings.bg_gradient_end || '')
    if (gs && ge) return { background: `linear-gradient(135deg, ${gs}, ${ge})` }
    return { backgroundColor: settings.bg_color || '#0b0c15' }
  })()

  const buttonStyle: React.CSSProperties = {
    backgroundImage: `linear-gradient(to right, ${settings.button_gradient_start || '#22d3ee'}, ${settings.button_gradient_end || '#bc48ff'})`
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-12" style={bgStyle}>
      <style>{String(settings.custom_css || '')}</style>
      <div className="text-center space-y-6" style={{ color: settings.text_color || '#ffffff', fontFamily: settings.font_family || 'inherit' }}>
        <h1 className="text-7xl font-display font-bold">404</h1>
        <h2 className="text-5xl font-bold">{settings.page_title || '404 - Page Not Found'}</h2>
        <p className="text-lg opacity-80">{settings.error_message || 'The page you are looking for does not exist.'}</p>
        <a href={settings.button_link || '/'} className="inline-block px-8 py-4 rounded-full text-black font-bold text-lg" style={buttonStyle}>
          {settings.button_text || 'Go Home'}
        </a>
      </div>
    </div>
  )
}

export default Error404
